<template>
  <div class="page_html">
    <bannerBox
      :title="title"
      :subtitle="subtitle"
    />
    <div
      v-for="cost in costs"
      :key="cost.id"
      :class="{'bg':cost.hasBg}"
    >
      <div class="costs">
        <p class="sub_title">
          {{ cost.title }}
        </p>
        <div class="content_S">
          <div class="hasSubTitle">
            {{ cost.hasSubTitle }}
          </div>
          <div>
            {{ cost.content }}
          </div>
          <div
            v-if="cost.hasImg"
            class="hasImg"
          >
            <img
              src="@/assets/solution/medicalCare/图层661.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
    <div class="costs">
      <p class="sub_title">
        方案价值
      </p>
      <Lists :values="values" />
    </div>
  </div>
</template>

<script>
import bannerBox from '@/views/solution/components/banner.vue'
import Lists from '@/views/solution/components/lists.vue'
export default {
  name: 'MedicalTreatment',
  components: {
    bannerBox,
    Lists
  },
  data() {
    return {
      title: '医疗行业办公终端安全解决方案',
      subtitle: '---医疗行业应用案例',
      costs: [
        {
          id: 1,
          title: '方案应用背景',
          content: `大数据、云计算、物联网等科技的发展正改变着医疗服务的模式和理念，这些新技术为就医
             增加了便捷，也为医院的智慧医疗发展提供了重要的支撑，然而，医疗行业面临的信息安全风险却逐渐增多。
             过去一年里，医疗领域就不断发生医患信息泄露的事件，引发了不少人的担忧。随着移动医疗、AI医疗影像、
             电子病历等等数字化程序的普及，越来越多医疗数据被收集，很多医疗信息由于涉及患者身体与疾病等隐私，
             比身份、财产、社会关系等其他个人信息更加敏感，泄露的杀伤力更大。
              因此，相关政策法规对医疗机构的信息安全建设提出了更高的要求，终端作为承载内外交流在重要环节，
              更是存着大量的数据，其安全管理已经是医疗机构信息安全建设的重中之重。
              此外，大部分医疗机构都面临终端运维难的困扰，医疗机构企业终端计算机众多，分布零散，软硬件资
              产信息统计困难，不断更新升级的系统软件也给信息管理员增加了不少的工作量，更别说系统补丁如果没有
              及时更新，会给终端带来风险，如何简化信息运维管理，提高风险防御能力，也是医疗机构企业最关心的问题。`
        },
        {
          id: 2,
          title: '安全需求分析',
          content: `面对业务系统中大量的终端，实现统一防病毒、统一补丁管理、终端安全策略管理、安全合规准
             入等多种管理功能是保证终端安全的基本需求。再来，需要有对网内所有终端进行统一管控与行为审计能力，
             建立完善的终端管控与行为审计体系，实现对终端的外接设备、移动存储设备、系统行为、网络行为、应用
             进程等多层次的管控与审计检测、响应和分析，掌握全网的信息资产安全状况，及时发现和处置安全事件。`,
          hasBg: true
        },
        {
          id: 3,
          title: '解决方案',
          content: `终端是一切恶意攻击的“着陆点”，而网络边界是恶意攻击要突破的第一道防线，作为安全防护体系
             部署的重要阵地，部署于终端与网络边界的安全措施应实现数据共享、协同防御及联动处置。终端安全管理系统
             可与智慧防火墙实现深度的终端数据共享，为边界安全产品提供多维的访问控制决策支撑，实现端网协同防控，
             配合终端准入系统提供的“一站式”准入控制流程，让内部网络管理变得安全、透明、可控，做到“协同联动、
             合规入网、安全可控”。`,
          hasSubTitle: '终端安全管理、终端准入、防火墙',
          hasImg: 'true'
        }
      ],
      values: [
        {
          id: 1,
          title: '一体化的管理平台',
          src: require('@/assets/solution/medicalCare/tubiao-dashboard.png'),
          content: '采用管理中心+客户端模式，大幅降低终端安全体系建设、运行、扩展的复杂性，支持可视化终端安全态势展示，实时呈现终端安全效果，针对性分析当前不足，统一推送更新加固任务，减少运维人员的日常维护难度。 '
        },
        {
          id: 2,
          title: '风险威胁闭环处置',
          src: require('@/assets/solution/medicalCare/yunxiazai-download.png'),
          content: ' 对终端面临的安全威胁进行闭环处置，提供统一、集中的补丁分发管理，集成多种病毒检测引擎有效查杀各种已知或未知病毒，并支持终端调查、威胁事件风险性评估，可对已确定的威胁实施面向进程、网络、主机的隔离、阻断等处置操作，大幅降低安全风险。'
        },
        {
          id: 3,
          title: '“一站式”终端准入',
          src: require('@/assets/solution/medicalCare/gongneng-function.png'),
          content: '能够帮客户轻松实现设备发现、资产识别、访客管理、认证授权、合规检查、隔离修复、权限管理、入网追踪等“一站式”准入控制流程，让内部网络管理变得安全、透明、可控，做到“协同联动、合规入网、安全可控”。 '
        },
        {
          id: 4,
          title: '发现威胁联动处置',
          src: require('@/assets/solution/medicalCare/yunfuwu-cloudserver.png'),
          content: ' 帮客户检测出传统手段无法检测出的威胁，最终定位本地威胁，同时智慧防火墙进行协同联动处置，阻断威胁的源头，达到全方位全天候感知网络威胁，实现高效的内网安全防护。'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.page_html {
  height: 100%;

  .costs {
    width: 100%;
    padding-top: 73px;
    padding-bottom: 90px;

    .sub_title {
      margin-bottom: 75px;
    }

    .content_S {
      width: 70%;
      margin: 0 auto;

      div {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
      }

      .hasSubTitle {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      .hasImg {
        width: 100%;
        height: 517px;
        margin-top: 48px;

        >img {
          width: 100%;
        }
      }
    }

  }

  .bg {
      background: #FAFBFF;
    }
}
@media screen and (min-width: 1200px) and (max-width: 1350px){
  .page_html .costs .content_S div{
    font-size: 20px;
  }
}
@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .page_html .costs .content_S div{
    font-size: 22px;
  }
}
@media screen and (min-width: 1500px) and (max-width: 1700px) {

}
@media screen and (min-width: 2000px) and (max-width: 2560px) {
  .page_html .costs .content_S .hasImg{
    height: 700px;
  }
}
</style>
